import { Reducer } from 'redux'
import {
  StorefrontMetricsActionTypes,
  type MetricsData,
  type StorefrontMetricsAction,
  initialStorefrontMetricsState,
} from './types'

export * from './types'

export const reducer: Reducer<MetricsData, StorefrontMetricsAction> = (
  state = initialStorefrontMetricsState,
  action
) => {
  switch (action.type) {
    case StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_DATA: {
      return {
        ...state,
        ...action.payload,
      }
    }
    case StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_DOMAIN: {
      return {
        ...state,
        domain: action.payload,
      }
    }
    case StorefrontMetricsActionTypes.SET_STOREFRONT_METRICS_PRODUCT: {
      return {
        ...state,
        selectedProduct: action.payload,
      }
    }
    case StorefrontMetricsActionTypes.SET_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.payload,
      }
    }
    case StorefrontMetricsActionTypes.CLEAR_STOREFRONT_METRICS_DATA:
      return initialStorefrontMetricsState

    default: {
      return state
    }
  }
}
